var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommingSoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 248,
    viewBox: "0 0 249 248",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_b_1976_46651)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.566406,
    y: 0.0878906,
    width: 247.863,
    height: 247.863,
    rx: 123.932,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.06641,
    y: 0.587891,
    width: 246.863,
    height: 246.863,
    rx: 123.432,
    stroke: "#E9E9E9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter1_b_1976_46651)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.8242,
    y: 15.3457,
    width: 217.349,
    height: 217.349,
    rx: 108.674,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3242,
    y: 15.8457,
    width: 216.349,
    height: 216.349,
    rx: 108.174,
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter2_b_1976_46651)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.082,
    y: 30.6035,
    width: 186.833,
    height: 186.833,
    rx: 93.4163,
    fill: "#768F99"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.582,
    y: 32.1035,
    width: 183.833,
    height: 183.833,
    rx: 91.9163,
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5786 114.44C85.5604 120.095 84.4355 126.344 84.4355 132.97C84.4355 146.133 88.8937 153.077 95.4202 157.049C102.383 161.287 112.421 162.613 124.497 162.613C136.572 162.613 146.611 161.287 153.575 157.049C160.102 153.077 164.561 146.133 164.561 132.97C164.561 126.345 163.436 120.097 161.418 114.442C161.482 115.343 161.514 116.252 161.514 117.169C161.514 137.83 144.996 154.68 124.498 154.68C103.997 154.68 87.482 137.83 87.482 117.169C87.482 116.252 87.5146 115.342 87.5786 114.44ZM94.4211 95.3005C85.8151 104.708 80.4355 118.103 80.4355 132.97C80.4355 161.436 100.162 166.613 124.497 166.613C148.831 166.613 168.561 161.436 168.561 132.97C168.561 118.105 163.182 104.711 154.577 95.3041C146.702 86.6954 136.126 81.4262 124.498 81.4258L124.497 81.4258C112.87 81.4258 102.295 86.6936 94.4211 95.3005ZM97.5215 97.8436C93.7172 103.305 91.482 109.972 91.482 117.169C91.482 135.677 106.262 150.68 124.498 150.68C142.731 150.68 157.514 135.677 157.514 117.169C157.514 109.973 155.279 103.307 151.476 97.8469C145.497 89.2629 135.642 83.6583 124.498 83.6583H124.497C113.353 83.6588 103.5 89.2619 97.5215 97.8436Z",
    fill: "#0E2B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.042 142.53C112.573 141.612 112.269 140.443 111.364 139.92C110.459 139.397 109.294 139.718 108.764 140.636C108.233 141.555 108.537 142.724 109.442 143.247C110.347 143.77 111.512 143.449 112.042 142.53Z",
    fill: "#0E2B3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.95 91.8082C136.419 92.7271 136.723 93.8957 137.629 94.4184C138.535 94.9411 139.699 94.6199 140.229 93.701C140.759 92.782 140.455 91.6134 139.55 91.0907C138.644 90.568 137.48 90.8892 136.95 91.8082Z",
    fill: "#0E2B3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.752 130.306C101.229 129.399 100.061 129.094 99.1423 129.624C98.224 130.153 97.9034 131.318 98.4263 132.224C98.9492 133.13 100.118 133.436 101.036 132.906C101.954 132.376 102.275 131.212 101.752 130.306Z",
    fill: "#0E2B3A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.966 101.438C147.047 101.968 146.726 103.133 147.249 104.038C147.773 104.943 148.941 105.247 149.86 104.716C150.779 104.185 151.099 103.021 150.576 102.116C150.053 101.21 148.884 100.907 147.966 101.438Z",
    fill: "#0E2B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3098 119.063C97.3708 119.063 98.2309 118.215 98.2309 117.17C98.2309 116.124 97.3708 115.276 96.3098 115.276C95.2488 115.276 94.3887 116.124 94.3887 117.17C94.3887 118.215 95.2488 119.063 96.3098 119.063Z",
    fill: "#0E2B3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.684 119.063C153.746 119.063 154.607 118.215 154.607 117.17C154.607 116.124 153.746 115.276 152.684 115.276C151.622 115.276 150.762 116.124 150.762 117.17C150.762 118.215 151.622 119.063 152.684 119.063Z",
    fill: "#0E2B3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4181 102.11C97.8952 103.015 98.2173 104.18 99.1375 104.711C100.058 105.243 101.228 104.939 101.75 104.034C102.273 103.129 101.951 101.964 101.031 101.432C100.111 100.901 98.941 101.204 98.4181 102.11Z",
    fill: "#0E2B3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.573 132.225C151.096 131.32 150.775 130.156 149.857 129.625C148.938 129.094 147.769 129.398 147.246 130.303C146.723 131.208 147.044 132.373 147.962 132.904C148.881 133.434 150.05 133.131 150.573 132.225Z",
    fill: "#0E2B3A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M108.763 93.7055C109.294 94.6241 110.458 94.9446 111.364 94.4214C112.269 93.8982 112.572 92.7294 112.041 91.8108C111.51 90.8921 110.346 90.5716 109.441 91.0948C108.536 91.618 108.232 92.7869 108.763 93.7055Z",
    fill: "#0E2B3A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M137.63 139.914C137.194 140.171 136.877 140.59 136.749 141.08C136.622 141.57 136.694 142.091 136.95 142.527C137.074 142.745 137.239 142.937 137.437 143.09C137.635 143.244 137.861 143.358 138.103 143.424C138.344 143.49 138.597 143.508 138.845 143.477C139.094 143.445 139.334 143.365 139.551 143.241C140.455 142.721 140.762 141.552 140.228 140.634C139.979 140.194 139.566 139.871 139.078 139.736C138.591 139.601 138.07 139.665 137.63 139.914Z",
    fill: "#0E2B3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.499 90.9048C125.544 90.9048 126.392 90.044 126.392 88.9822C126.392 87.9203 125.544 87.0596 124.499 87.0596C123.453 87.0596 122.605 87.9203 122.605 88.9822C122.605 90.044 123.453 90.9048 124.499 90.9048Z",
    fill: "#0E2B3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M124.499 147.279C125.544 147.279 126.392 146.418 126.392 145.356C126.392 144.294 125.544 143.434 124.499 143.434C123.453 143.434 122.605 144.294 122.605 145.356C122.605 146.418 123.453 147.279 124.499 147.279Z",
    fill: "#0E2B3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M126.678 93.7793C137.429 94.8706 145.82 103.952 145.82 114.991C145.82 126.767 136.273 136.314 124.495 136.314C112.717 136.314 103.172 126.767 103.172 114.991C103.172 103.95 111.561 94.8706 122.313 93.7793C110.361 94.8809 100.998 104.927 100.998 117.169C100.998 130.147 111.517 140.669 124.497 140.669C137.476 140.669 147.998 130.147 147.998 117.169C147.998 104.927 138.633 94.8809 126.678 93.7793Z",
    fill: "#0E2B3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.009 108.22C122.922 113.723 122.256 120.365 122.256 124.793C122.256 126.231 122.708 126.945 123.046 127.286C123.42 127.663 123.937 127.873 124.498 127.873C125.059 127.873 125.576 127.663 125.949 127.286C126.288 126.945 126.74 126.231 126.74 124.793C126.74 120.365 126.074 113.723 124.988 108.22C124.83 107.419 124.666 106.658 124.498 105.946C124.331 106.659 124.167 107.419 124.009 108.22ZM126.381 100.456C126.411 100.418 126.41 100.425 126.379 100.46L126.381 100.456ZM122.619 100.459C122.587 100.424 122.586 100.418 122.616 100.456L122.619 100.459ZM118.256 124.793C118.256 115.351 121.051 97.1797 124.499 97.1797C127.947 97.1797 130.74 115.351 130.74 124.793C130.74 134.233 118.256 134.233 118.256 124.793Z",
    fill: "#0E2B3A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1976_46651",
    x: -69.4336,
    y: -69.9121,
    width: 387.863,
    height: 387.863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_1976_46651",
    x: -54.1758,
    y: -54.6543,
    width: 357.35,
    height: 357.349,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46651",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_1976_46651",
    x: -38.918,
    y: -39.3965,
    width: 326.832,
    height: 326.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1976_46651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1976_46651",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommingSoon);
export default __webpack_public_path__ + "static/media/CommingSoon.0d2feac1578c072b70b53c416d98d6a7.svg";
export { ForwardRef as ReactComponent };